import {
  SET_SUBMITTED,
  SHOW_ADDRESS_FORM,
  SET_ERRORS
} from '../actionTypes/ui';


export const setSubmitted = (submitted) => ({
  type: SET_SUBMITTED,
  submitted: submitted
});

export const showAddressForm = (showAddressForm = true) => ({
  type: SHOW_ADDRESS_FORM,
  showAddressForm
});

export const setErrors = (errors) => ({
  type: SET_ERRORS,
  errors
});


// WEBPACK FOOTER //
// ./src/actions/ui.js